export default __webpack_public_path__ + "f968946e065a58eee0070bf2cc939e64.png";